import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/jukeTreasureApi'

class Store {
  id

  @observable data = {}
  @action
  getInfo = async () => {
    const { id } = this
    let { data } = await Api.view({ id })
    runInAction(() => {
      this.data = data
    })
  }
}
export default new Store()
